import { Injectable } from '@angular/core';

import { HttpClient, HttpResponse } from '@angular/common/http';
import { ParamMap } from '@angular/router';

import { Observable, combineLatest, Subject, BehaviorSubject, ReplaySubject } from 'rxjs';
import { map, flatMap, tap, switchMap, switchAll, take } from 'rxjs/operators';


import { Real } from '../models/real.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExposedService {

  constructor( private http: HttpClient ) {
  }

  getNewOnMarketplace() {
    return this.getPromoted();
  }  

  getExposedOnMarketplace() {
    return this.getPromoted(0,1,0);
  } 

  getSpecialOfferOnMarketplace() {
    return this.getPromoted(0,0,1);
  } 

  getPromoted( newOnMarketplace = 1, exposedOnMarketplace = 0, specialOfferOnMarketplace = 0 ) {
    
    const responseToModel = ( response: any): any =>  {

      if ( response._embedded && response._embedded.real ) {
        return response._embedded.real.map(
          realApiData => new Real( realApiData )
        )

      } else {
        return [];
      }

    } 

    const apiUrl = environment.apiUrl + '/';
    const endpoint = 'providers/1/reals';

    let query: string[] = [];

    query.push('allProviders=1');
    query.push('expand=provider');
    query.push('table42=1');

    if ( newOnMarketplace ) {
      query.push('newOnMarketplace=1');
    }

    if ( exposedOnMarketplace ) {
      query.push('exposedOnMarketplace=1');
    }

    if ( specialOfferOnMarketplace ) {
      query.push('specialOfferOnMarketplace=1');
    }

    query.push('pageSize=100');

    const url = apiUrl + endpoint + '?' + query.join('&');

    return this.http.get( url ).pipe(
       map ( response => responseToModel( response ) )
    );

  }

}
